import { render, staticRenderFns } from "./record_tpl.vue?vue&type=template&id=fea5b254&scoped=true&"
import script from "./record_tpl.vue?vue&type=script&lang=js&"
export * from "./record_tpl.vue?vue&type=script&lang=js&"
import style0 from "./record_tpl.vue?vue&type=style&index=0&id=fea5b254&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea5b254",
  null
  
)

export default component.exports